import { SidePanel } from "components/Sidepanel/SidePanel";
import React, { useState } from "react";
import "./sidebar.css";
import { NavLink, Route, Routes, useNavigate } from "react-router-dom";


import {
  HiOutlineArrowNarrowLeft,
  HiOutlineArrowNarrowRight,
} from "react-icons/hi";


import { MyGoal } from "container/Interviewee/MyGoals/MyGoal";
import { HelpDocumentation } from "components/common/Support/HelpDocumentation";
import { SupportFeedback } from "components/common/Support/SupportFeedback";
import { Dashboard } from "container/CollegeStudent/Dashboard/Dashboard";
import { AiFillHome } from "react-icons/ai";
import { Profile } from "container/CollegeStudent/Profile/Profile";
import { PracticeInterview } from "container/CollegeStudent/PracticeInterview/PracticeInterview";
import { NavbarCollegeStudent } from "components/Navbar/NavbarCollegeStudent";
import { MyInterview } from "container/CollegeStudent/MyInterview/MyInterview";
import { IndexInterview } from "container/ActualInterview/IndexInterview";
import Notification from "container/CollegeStudent/Notifications/Notification";
import Reports from "container/Interviewee/Reports/Reports";
import { PracticeJobInterview } from "container/Interviewee/JobInterview/PracticeJobInterview";
import { Interviewee } from "container/CollegeStudent/InterviewCourses/Interviewee";
import { SingleCourse } from "container/CollegeStudent/InterviewCourses/SingleCourse";
import Cookies from "js-cookie";

export const SideBarAndHeaderCollegeStudent = ({ data }) => {
  const [hideSidebar, setHideSidebar] = useState(false);
  const [updateprofile, setupdateprofile] = useState(true)

  const navigate = useNavigate();
  const Logout = () => {
    const yes = window.confirm("Are you sure you want to logout?");
    if (yes) {
      Cookies.remove("token");
      Cookies.remove("role");
      Cookies.remove("name");
      Cookies.remove("email");
      Cookies.remove("profileImg");
      Cookies.remove("collegeID");
      Cookies.remove("userDetails");
      Cookies.remove("profile");
      Cookies.remove("loginType");
      Cookies.remove("profileImage");
      Cookies.remove("company");
      navigate("/");
    }
  };
  return (
    <>
      <div className="d-flex">
        <div className={`${hideSidebar ? "col-w-6" : "col-w-20"} d-none-968`}>
          <SidePanel hideSidebar={hideSidebar}>
            <div className="px-3 py-4">
              <div className="min-height-sidebar">
                {data.slice(0, 5).map((item) => (
                  <NavLink
                    to={item.path}
                    className="sidebar__link"
                    key={item.id}
                  >
                    <div
                      className={`${hideSidebar ? "wrapper__sidebar_hide" : ""
                        } d-flex align-items-center py-2 wrapper__sidebar`}
                    >
                      {item.icon}
                      {!hideSidebar && (
                        <h6 className="sidebar__heading px-2 mt-2">
                          {item.name}
                        </h6>
                      )}
                    </div>
                  </NavLink>
                ))}
                <hr />
                {data.slice(5, 8).map((item) => (
                  <NavLink
                    to={item.path}
                    className="sidebar__link"
                    key={item.id}
                  >
                    <div
                      className={`${hideSidebar ? "wrapper__sidebar_hide" : ""
                        } d-flex align-items-center py-2 wrapper__sidebar`}
                    >
                      {item.icon}
                      {!hideSidebar && (
                        <h6 className="sidebar__heading px-2 mt-2">
                          {item.name}
                        </h6>
                      )}
                    </div>
                  </NavLink>
                ))}
                <a className="sidebar__link" href="https://viosa.in/">
                  {!hideSidebar ? (
                    <div
                      className="d-flex align-items-center py-2 wrapper__sidebar

                  cursor-pointer"
                    >
                      <AiFillHome />
                      <h6 className="sidebar__heading px-2 mt-2">Go To Dashboard</h6>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center py-2 wrapper__sidebar wrapper__sidebar_hide cursor-pointer">
                      <AiFillHome />
                    </div>
                  )}
                </a>
              </div>
              <div
                className="sidebar__link"
                onClick={() => {
                  setHideSidebar(!hideSidebar);
                }}
              >
                {!hideSidebar ? (
                  <div className="d-flex align-items-center py-2 wrapper__sidebar cursor-pointer">
                    <HiOutlineArrowNarrowLeft />
                    <h6 className="sidebar__heading px-2 mt-2">Hide Sidebar</h6>
                  </div>
                ) : (
                  <div className="d-flex align-items-center py-2 wrapper__sidebar cursor-pointer wrapper__sidebar_hide">
                    <HiOutlineArrowNarrowRight />
                  </div>
                )}
              </div>
            </div>
          </SidePanel>
        </div>
        <div className={`${hideSidebar ? "col-w-94" : "col-w-80"} w-100-968`}>
          <div className="w-100">
            <NavbarCollegeStudent updateprofile={updateprofile} setupdateprofile={setupdateprofile} />
            <div className="main-content ">
              <Routes>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/dashboard/:id" element={<Dashboard />} />
                <Route path="/interview-courses" element={<Interviewee />} />
                <Route
                  path="/interview-courses/:id"
                  element={<SingleCourse />}
                />
                <Route
                  path="/practice-interview"
                  element={<PracticeInterview />}
                />
                <Route
                  path="/practice-interview/:id"
                  element={<PracticeInterview />}
                />
                {/* <Route
                  path="/practice-interview/interview/*"
                  element={<IndexInterview />}
                /> */}
                <Route path="/my-interview" element={<MyInterview />} />
                <Route
                  path="/my-interview/:id"
                  element={<PracticeJobInterview />}
                />
                <Route
                  path="/interview-video/:id"
                  element={<PracticeJobInterview />}
                />
                <Route path="/my-goals" element={<MyGoal />} />
                <Route path="/profile" element={<Profile updateprofile={updateprofile} setupdateprofile={setupdateprofile} />} />
                <Route path="/support-feedback" element={<SupportFeedback />} />
                <Route path="/help" element={<HelpDocumentation />} />
                <Route path="/reports/:id" element={<Reports />} />
                <Route path="/notifications" element={<Notification />} />
                {/* <Route path="/notifications" element={<HelpDocumentation />} /> */}
              </Routes>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
